import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";


// notificationCallback: (message, type) => void
export const initiatePurchase = async (series, user, navigate, notificationCallback) => {
  if (!user) {
    if (notificationCallback) notificationCallback("Please login to purchase this test series.", "error");
    else alert("Please login to purchase this test series.");
    return;
  }

  try {
    if (notificationCallback) notificationCallback("Contacting payment server...", "info");

    const createOrderFn = httpsCallable(functions, "createOrder");
    const verifyPaymentFn = httpsCallable(functions, "verifyPayment");

    // Clean the price (Remove ₹ and commas)
    const numericPrice = parseInt(series.price.replace(/[^\d]/g, ""));

    // Step A: Create Order on Server
    const orderRes = await createOrderFn({
      amount: numericPrice,
      seriesId: series.id
    });

    const order = orderRes.data;

    // Step B: Get Razorpay Key from environment
    const razorpayKey = process.env.REACT_APP_RAZORPAY_KEY_ID;
    
    if (!razorpayKey) {
      throw new Error("Razorpay Key not configured. Please check environment variables.");
    }

    // Step C: Open Razorpay Popup
    const options = {
      key: razorpayKey,
      amount: order.amount,
      currency: "INR",
      name: "PrrepX Pathshala",
      description: series.title,
      order_id: order.id,
      handler: async (response) => {
        try {
          if (notificationCallback) notificationCallback("Verifying payment...", "info");
          // Step D: Verify on Server after success
          const verifyResult = await verifyPaymentFn({
            ...response,
            seriesId: series.id,
            amount: numericPrice,
            title: series.title
          });

          if (verifyResult.data.status === "success") {
            if (notificationCallback) notificationCallback("💰 Payment Successful! Access Granted to Test Series.", "success");
            else alert("💰 Payment Successful! Access Granted to Test Series.");
            navigate("/profile");
          } else {
            if (notificationCallback) notificationCallback("Payment verification failed. Please contact support.", "error");
            else alert("Payment verification failed. Please contact support.");
          }
        } catch (verifyError) {
          console.error("Payment verification error:", verifyError);
          if (notificationCallback) notificationCallback("Verification failed. Please contact support with Order ID: " + response.razorpay_order_id, "error");
          else alert("Verification failed. Please contact support with Order ID: " + response.razorpay_order_id);
        }
      },
      prefill: {
        name: user.displayName || "",
        email: user.email || "",
        contact: user.phoneNumber || "",
      },
      theme: { color: "#1d4ed8" },
      modal: {
        ondismiss: () => {
          if (notificationCallback) notificationCallback("Payment cancelled by user.", "warning");
          else console.log("Payment cancelled by user");
        }
      }
    };

    if (notificationCallback) notificationCallback("Opening payment gateway...", "info");
    const rzp = new window.Razorpay(options);
    rzp.open();

  } catch (error) {
    console.error("Payment Process Error:", error);
    if (notificationCallback) {
      if (error.message && error.message.includes("Razorpay Key not configured")) {
        notificationCallback("Payment gateway is not properly configured. Please contact support.", "error");
      } else if (error.code === "functions/unauthenticated") {
        notificationCallback("Session expired. Please log in again.", "error");
      } else {
        notificationCallback("Could not initiate payment. Please try again or contact support.", "error");
      }
    } else {
      if (error.message && error.message.includes("Razorpay Key not configured")) {
        alert("Payment gateway is not properly configured. Please contact support.");
      } else if (error.code === "functions/unauthenticated") {
        alert("Session expired. Please log in again.");
      } else {
        alert("Could not initiate payment. Please try again or contact support.");
      }
    }
  }
};